import clsx from "clsx";

import { Heading } from "@/components/atoms";

import type { MarqueeData } from "../Footer";
import styles from "./marquee.module.css";

const Marquee = ({ data }: { data: MarqueeData }) => {
  if (!data) return null;
  return (
    <div className={styles.marquee}>
      <div className={styles.marquee__element}>
        {data?.map((text, i) => (
          <Heading as="p" styledAs="h3" key={i}>
            {text}
          </Heading>
        ))}
      </div>
      <div className={clsx(styles.marquee__element, styles.second__marquee)}>
        {data?.map((text, i) => (
          <Heading as="p" styledAs="h3" key={i}>
            {text}
          </Heading>
        ))}
      </div>
    </div>
  );
};
export default Marquee;
